module.exports = require('./main').default;